import { useSearchParams } from 'react-router-dom';
import BadgeStepper from 'components/BadgeStepper';

export default function StepperParamContainer() {
  const [searchParams] = useSearchParams();
  return <BadgeStepper activeStep={Number(searchParams.get('step')) || 1} />;
}
